module.exports = __webpack_public_path__ + "static/media/anjali_phule.f0b9c3a4.png";